<template>
	<div class="CheckOrder">
		<div class="or-nav">
			<van-nav-bar :fixed="true">
				<template #left>
					<div class="left-text">
						<div class="logo"><img class="auto-img" src="../assets/images/coffee_icon.jpg" alt=""></div>
						<div class="logo-title">Luckin Coffee</div>
					</div>
				</template>
				<template #right>
					<div class="right-text" @click="back">
						返回
					</div>
				</template>
			</van-nav-bar>
		</div>


		<div class="or-tab">
			<div class="or-tab-box">
				<van-tabs v-model="tabIndex" color="#212572" line-height="2px" @change="toggleStatus">
					<van-tab :title="v.title" v-for="(v, i) in tabItems" :key="i">
						<div class="tab-box" v-for="(item, index) in orderDatas" :key="index">
							<div class="clearfix tab-item-box">
								<div class="fl or-Number">{{item.orderId}}</div>
								<div class="fr status-delect">
									<div class="or-status" v-if="item.status == 1" @click="confirmReceive(item, index)">确认收货</div>
									<div class="finished" v-else>
										<div class="or-status">已完成</div>
										<div class="or-delete" @click="removeOrder(item.orderId, index)">
											<van-icon name="delete" />
										</div>
									</div>
								</div>
							</div>

							<div class="bag-product" v-for="(v,i) in item.products" :key="i">
								<van-swipe-cell>
									<van-cell :border="false">
										<div class="clearfix">
											<div class="fl pro-img">
												<img class="auto-img" :src="v.smallImg" alt="">
											</div>
											<div class="fl pro-info">
												<div class="text-box">
													<div class="clearfix nameAndRule">
														<div class="fl text-name">{{v.name}}</div>
														<div class="fl text-rule">{{v.rule}}</div>
													</div>
													<div class="text-enname">{{v.enname}}</div>
												</div>
												<div class="price-box clearfix">
													<div class="price fl">￥{{v.price}}</div>
													<div class="count fr">
														x {{v.count}}
													</div>
												</div>
											</div>
										</div>
									</van-cell>
								</van-swipe-cell>
							</div>

							<div class="order-price">
								<div class="clearfix order-price-box">
									<div class="date">{{item.date | formatDate('yyyy-MM-dd hh:mm:ss')}}</div>
									<div class="fl pro-count">共计{{item.count}}件商品</div>
									<div class="fr pro-total">合计￥{{item.total}}</div>
								</div>
							</div>
						</div>
					</van-tab>
				</van-tabs>
			</div>
		</div>

		<div class="Empty">
			<van-empty description="订单空空如也" v-if="orderDatas.length <= 0" :image="carimgurls">
				<van-button round class="bottom-button" @click="goMenu">
					快去选购你喜欢的商品吧
				</van-button>
			</van-empty>
		</div>


	</div>
</template>

<script>
	import '../assets/less/checkorder.less'
	import {
		utils
	} from '../assets/js/utils'
	export default {
		data() {
			return {
				n: '2020-08-15T10:29:26.000Z',
				tabIndex: 0,
				orderDatas: [],
				carimgurls: 'https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=3561565621,665011732&fm=26&gp=0.jpg',
				tabItems: [{
						title: '全部'
					},
					{
						title: '进行中'
					},
					{
						title: '已完成'
					},
				]
			}
		},
		created() {
			this.getOrderData(0);
		},
		methods: {

			//返回my
			back() {
				this.$router.push({
					name: 'My'
				});
			},

			//前往菜单
			goMenu() {
				this.$router.push({
					name: 'Menu'
				})
			},

			//获取订单数据
			getOrderData(status) {

				//status: 订单情况
				//获取token
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'GET',
					url: '/findOrder',
					params: {
						appkey: this.appkey,
						tokenString,
						status
					}
				}).then(result => {
					this.orderDatas = [];
					this.$toast.clear();
					if (result.data.code == 70000) {
						let orderData = {};
						result.data.result.map(v => {
							if (!orderData[v.oid]) {
								// 如果不存在订单数据，则初始化一个对象
								orderData[v.oid] = {
									orderId: v.oid,
									date: v.createdAt,
									count: v.count,
									total: v.count * v.price,
									products: [v],
									status: v.status
								}

							} else {
								orderData[v.oid].count += v.count;
								orderData[v.oid].total += v.count * v.price;
								orderData[v.oid].products.push(v);
							}
						})

						for (let key in orderData) {
							this.orderDatas.push(orderData[key]);
						}

						this.orderDatas.sort((a, b) => {
							return new Date(b.date).getTime() - new Date(a.date).getTime();
						})

					}
				}).catch(err => {
					this.$toast.clear();
				})
			},

			//切换订单状态
			toggleStatus(name) {
				this.getOrderData(name);
			},


			//确认收货
			confirmReceive(item, index) {
				//item.orderId: 订单号
				//item.status: 订单状态
				//item.index: 下标

				//检查是否有token
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				//参数序列化
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					oid: item.orderId
				})


				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'POST',
					url: '/receive',
					data
				}).then(result => {

					this.$toast.clear();

					if (result.data.code == 80000) {
						this.$toast(result.data.msg);
						if (this.tabIndex == 1) {
							//进行中
							this.orderDatas.splice(index, 1);
						} else {
							item.status = 2;
						}
					}
				}).catch(err => {
					this.$toast.clear();
				})
			},


			// 删除订单
			removeOrder(oid, index) {

				//检查是否有token
				let tokenString = localStorage.getItem('RETK');
				if (!tokenString) {
					return;
				}

				//参数序列化
				let data = utils.queryString({
					appkey: this.appkey,
					tokenString,
					oid
				})


				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					duration: 0,
					loadingType: 'spinner'
				})

				this.axios({
					method: 'POST',
					url: '/removeOrder',
					data
				}).then(result => {

					this.$toast.clear();

					if (result.data.code == 90000) {
						this.$toast(result.data.msg);
						this.orderDatas.splice(index, 1);
					}

				}).catch(err => {
					this.$toast.clear();

				})
			}
		}
	}
</script>
<style>
</style>
